import HttpService from '../../../services/HttpService';

interface FeedbackDTO {
    message: string;
    email: string;
    path: string;
    name: string;
    reCaptchaResponse: string
}

export async function sendFeedback(details: FeedbackDTO): Promise<boolean> {
    return await HttpService.post(process.env.GATSBY_FEEDBACK_URL, details, { headers: { "Content-Type": "application/json" } });
}
